import { ReactNode, useEffect } from "react";

import { useAppDispatch } from "cortex/ui/src/hooks";
import {
  setLoaderStatusAction,
  setLoaderTextAction,
} from "cortex/ui/src/redux-store/loader/actions";

interface NavLoaderProxyProps {
  children?: ReactNode;
}

export default function NavLoaderProxy({ children }: NavLoaderProxyProps) {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(setLoaderStatusAction(true));
    dispatch(setLoaderTextAction(children));

    return () => {
      dispatch(setLoaderStatusAction(false));
      dispatch(setLoaderTextAction(null));
    };
  }, [children, dispatch]);

  return null;
}
